import styled from '@emotion/styled';
import { MOBILE_BREAKPOINT } from '../PaywallsShared/constants';

// TODO: https://anchorfm.atlassian.net/browse/CAST-2581: Remove all isInNav vs PSC flow logic when we remove the
// language selector from the PSC flow and solely use the navbar langauge selector for the full site.
export const StyledLanguageSelectorContainer = styled.div<{ isInNav: boolean }>`
  position: ${({ isInNav }) => (isInNav ? 'relative' : 'absolute')};
  top: 0;
  right: 0;
  display: flex;
  margin-left: ${({ isInNav }) => (isInNav ? '10px' : '0')};

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    top: ${({ isInNav }) => (isInNav ? 0 : 20)}px;
    right: ${({ isInNav }) => (isInNav ? 0 : 20)}px;
  }
`;

// TODO: https://anchorfm.atlassian.net/browse/CAST-2581: Remove all isInNav vs PSC flow logic when we remove the
// language selector from the PSC flow and solely use the navbar langauge selector for the full site.
export const StyledLanguageSelectorDisplay = styled.div<{ isInNav: boolean }>`
  display: flex;
  align-items: center;
  width: auto;
  height: 20px;
  cursor: pointer;

  svg[aria-labelledby*='globeIcon'] {
    width: 14px;
    height: 14px;
    margin-right: 4px;

    path {
      fill: ${({ isInNav }) => (isInNav ? '#FFFFFF' : 'rgb(95, 99, 105)')};
    }
  }

  svg:not([aria-labelledby*='globeIcon']) {
    width: 10px;
    height: 10px;
    opacity: ${({ isInNav }) => (isInNav ? '1' : '0.7')};
    stroke: ${({ isInNav }) => (isInNav ? '#FFFFFF' : '#292f36')};
  }

  span {
    margin-right: 4px;
    color: ${({ isInNav }) => (isInNav ? '#FFFFFF' : '#292f36')};
    font-size: 1.4rem;
    line-height: 2rem;
    text-transform: uppercase;
    opacity: ${({ isInNav }) => (isInNav ? '1' : '0.7')};
  }
`;

export const StyledLanguageSelectorListContainer = styled.div`
  position: relative;
`;

// TODO: https://anchorfm.atlassian.net/browse/CAST-2581: Remove all isInNav vs PSC flow logic when we remove the
// language selector from the PSC flow and solely use the navbar langauge selector for the full site.
export const StyledLanguageSelectorList = styled.ul<{ isInNav: boolean }>`
  position: absolute;
  padding: 6px;
  border: 2px solid #dedfe0;
  border-radius: 6px;
  background: #f2f2f3;
  ${({ isInNav }) =>
    isInNav
      ? `
    left: 0;
    z-index: 100;

    @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
      left: unset;
      right: 0;
    }`
      : 'right: 0'};

  li {
    margin: 0;
    font-size: 1.4rem;
    line-height: 2rem;
  }
`;

export const StyledLanguageSelectorListItem = styled.li<{
  isSelected?: boolean;
}>`
  list-style: none;
  padding: 0px 6px 1px 14px;
  font-weight: ${({ isSelected }) => (isSelected ? 'bold' : 'normal')};
  cursor: pointer;
  position: relative;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background: #4c8bf5;
  }

  ${({ isSelected }) =>
    isSelected
      ? `
      pointer-events: none;
      &::before {
        content: "\\2713";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    `
      : ''}
`;
